import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";

import { useAuth } from "../../contexts/AuthContext";

import LoadingInformation from "../../common/UI/LoadingInformation";

export default function LoginByToken() {
  const [searchParams] = useSearchParams();
  const { login, loading } = useAuth();

  const [messageDescription, setMessageDescription] = useState('');
  const [, setOpenModal] = useState<boolean>(false);
  const [errorType, setErrorType] = useState<number | null>(null);
  // Obtener el token de los parámetros de la URL
  const token: string = searchParams.get("token") ?? '';
  useEffect(() => {
    login(token);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleCloseModal = () => {
    setOpenModal(false);
    setErrorType(null);
    setMessageDescription('');
  };

  return (
    <div className="login-by-token-page">
      <LoadingInformation
        name={''}
        description={messageDescription}
        isOpen={true}
        onClose={handleCloseModal}
        isLoading={loading}
        responseStatus={errorType}
      />
    </div>
  );
}
